import { Periodicity } from '@ecosystem/newron-core/types';
import { PeriodAggregation, TimeFrameOption } from '../types';
import { FirstWeekContainsDate, addDays, startOfISOWeekYear, startOfWeekYear } from 'date-fns';

const getWeekDates = (option: TimeFrameOption, isISOWeekNumber: boolean): [Date, Date] => {
  if (!option || option.aggregation !== PeriodAggregation.Week) {
    return [undefined, undefined];
  }

  const [week, year] = option.label.split(' ');
  const weekNumber = Number(week.replace('W', ''));
  const yearNumber = Number(year);

  const weekNumberToDate = (weekNumber: number, year: number, isISOWeekNumber: boolean) => {
    const randomDateInYear = new Date(year, 5, 5);
    const startOfFirstWeekDate = isISOWeekNumber
      ? startOfISOWeekYear(randomDateInYear)
      : startOfWeekYear(randomDateInYear, {
          firstWeekContainsDate: 3 as FirstWeekContainsDate,
        });
    const targetDate = addDays(startOfFirstWeekDate, (weekNumber - 1) * 7);
    return targetDate;
  };

  const date = weekNumberToDate(weekNumber, yearNumber, isISOWeekNumber);

  return [date, addDays(date, 6)];
};

const getWeekStart = (option: TimeFrameOption, isISOWeekNumber: boolean): Date => {
  const [start, _end] = getWeekDates(option, isISOWeekNumber);
  return start;
};

const getWeekEnd = (option: TimeFrameOption, isISOWeekNumber: boolean): Date => {
  const [_start, end] = getWeekDates(option, isISOWeekNumber);
  return end;
};

const getPeriodicity = (aggregation: PeriodAggregation): Periodicity => {
  return aggregation === PeriodAggregation.Week ? Periodicity.Weekly : Periodicity.Monthly;
};

export { getWeekStart, getWeekEnd, getPeriodicity };
